import React, { useState } from "react";
import {
    Box,
    Card,
    Text,
    Heading,
    Button,
    Flex,
    Image
} from "rebass";
import {
    FaApple,
    FaAndroid,
    FaPhoneAlt,
} from "react-icons/fa";
import Modal from 'app/modal/v3/index';
import { BiTimeFive } from "react-icons/bi";
import {
    BsChatDots,
} from "react-icons/bs";
import {
    MdLanguage,
} from "react-icons/md";
import {
    IoClose,
} from "react-icons/io5";

import IconList from './assets/IconList.png'

const iconItems = [
    {
        label: "Text",
        icon: BsChatDots,
        bg: "#5AA7F8",
    },
    {
        label: "Calls",
        icon: FaPhoneAlt,
        bg: "#62C36F",
    },
    {
        label: "Internet",
        icon: MdLanguage,
        bg: "#4B9BE8",
    },
    {
        label: "Baby\nYearbooks",
        icon: BsChatDots,
        bg: "#B05AD7",
    },
];

const iosSteps = [
    "Open Safari and go to app.babyyearbooks.com",
    "Tap the <b>Share icon</b> (the square with an arrow pointing up)",
    "Scroll down and tap <b>Add to Home Screen</b>",
    "Rename the icon if you like, then tap <b>Add</b>",
];

const androidSteps = [
    "Open Chrome and visit app.babyyearbooks.com",
    "Tap the <b>three dots menu</b> in the top-right corner",
    "Select <b>Add to Home Screen</b>",
    "Customize the name if you want, then tap <b>Add</b>",
];

const StepItem = ({ number, text }) => (
    <Flex mb={2} alignItems="flex-start">
        <Box
            width={22}
            height={22}
            mr={1}
            fontFamily={"Poppins"}
            sx={{
                borderRadius: "50%",
                background: "#D8EBFF",
                color: "#2E7CF6",
                fontWeight: 700,
                fontSize: 12.235,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
            }}
        >
            {number}
        </Box>

        <Text
            fontSize={1}
            lineHeight="160%"
            color="#333"
            fontWeight={400}
            fontFamily={"Poppins"}
            dangerouslySetInnerHTML={{ __html: text }} />

    </Flex >
);

const PlatformToggle = ({
    active,
    value,
    icon,
    label,
    onClick,
}) => (
    <Button
        onClick={onClick}
        variant="outline"
        sx={{
            cursor: "pointer",
            borderRadius: '999px',
            border: `1px solid ${active === value ? "#9B59D0" : "#CFCFCF"
                }`,
            bg: active === value ? "#F6EEFF" : "#FFF",
            color: active === value ? "#7A34B8" : "#444",
            fontWeight: 600,
            fontSize: 1,
            px: 3,
            py: 2,
            display: "flex",
            alignItems: "center",
            gap: 1,
            transition: "all .2s ease",
            "&:hover": {
                bg: "#F7F2FC",
            },
        }}
    >
        {icon}
        <Text fontFamily="Poppins" fontSize={16} lineHeight={20}>{label}</Text>
    </Button>
);

const AppInstallModal = ({
    isOpen = true,
    onClose = () => { },
}) => {
    const [platform, setPlatform] = useState("iphone");

    if (!isOpen) return null;

    const isIOS = platform === "iphone";

    return (
        <Modal
            close={{ onClose }}
            title=""
            closeOnOutsideClick={false}
            isScrollActive={false}
            aboveTooltip
            noHeader
            shadeProps={{ pt: [0, 4] }}
        >
            <Flex
            // sx={{
            //     position: "fixed",
            //     inset: 0,
            //     bg: "rgba(0,0,0,0.45)",
            //     alignItems: "center",
            //     justifyContent: "center",
            //     zIndex: 9999,
            //     p: 3,
            // }}
            >
                <Card
                    p={4}
                    sx={{
                        width: "100%",
                        // maxWidth: 10,
                        borderRadius: 18,
                        bg: "#FFF",
                        position: "relative",
                        boxShadow:
                            "0 10px 40px rgba(0,0,0,0.18)",
                        fontFamily:
                            '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                    }}
                >
                    {/* Close */}
                    <Box
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            top: 14,
                            right: 14,
                            cursor: "pointer",
                            color: "#888",
                        }}
                    >
                        <IoClose size={20} />
                    </Box>

                    {/* Tag */}
                    <Box
                        mb={2}
                        sx={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 1,
                            px: 3,
                            py: "6px",
                            borderRadius: '999px',
                            bg: "#D9EBFF",
                            color: "#2F7CF6",
                            fontWeight: 600,
                            fontSize: 14,
                            fontFamily: "Poppins",
                        }}
                    >
                        <BiTimeFive size={20} />
                        Time Saving Tip for Mobile
                    </Box>

                    {/* Heading */}
                    <Heading
                        as="h2"
                        fontFamily="Bitter"
                        fontSize={"26px"}
                        mb={2}
                        color="#000"
                        lineHeight="165%"
                    >
                        Access stories with one tap
                    </Heading>

                    <Text
                        mb={2}
                        color="#444"
                        fontSize={16}
                        lineHeight="26px"
                        fontFamily="Poppins"
                    >
                        Add Baby Yearbooks to your home screen
                        for instant access – no browser
                        searching
                    </Text>
                    <Flex justifyContent="center" my={3}>
                        <Image src={IconList} maxWidth={330} m="auto" />
                    </Flex>

                    {/* Platform Selector */}
                    <Flex sx={{
                        gap: 2
                    }} my={2}>
                        <PlatformToggle
                            active={platform}
                            value="iphone"
                            icon={<FaApple />}
                            label="iPhone"
                            onClick={() =>
                                setPlatform("iphone")
                            }
                        />

                        <PlatformToggle
                            active={platform}
                            value="android"
                            icon={<FaAndroid />}
                            label="Android"
                            onClick={() =>
                                setPlatform("android")
                            }
                        />
                    </Flex>

                    {/* Steps */}
                    <Text
                        mb={2}
                        fontWeight={400}
                        color="#444"
                        fontSize={16}
                        fontFamily={"Poppins"}
                    >
                        HOW TO SET IT UP
                    </Text>

                    {(isIOS
                        ? iosSteps
                        : androidSteps
                    ).map((step, idx) => (
                        <StepItem
                            key={idx}
                            number={idx + 1}
                            text={step}
                        />
                    ))}

                    {/* Actions */}
                    <Button
                        width="100%"
                        sx={{
                            borderRadius: '999px',
                            bg: "##9B59B6",
                            color: "#FFF",
                            fontWeight: 700,
                            py: 3,
                            cursor: "pointer",
                            "&:hover": {
                                bg: "#9448C7",
                            },
                        }}
                        onClick={onClose}
                    >
                        Got it – I’ll add it now
                    </Button>

                    <Button
                        mt={2}
                        mb={8}
                        width="100%"
                        variant="outline"
                        sx={{
                            borderRadius: '999px',
                            border: "1px solid #9B59B6",
                            color: "#9B59B6",
                            bg: "#FFF",
                            fontWeight: 600,
                            py: 3,
                            cursor: "pointer",
                            "&:hover": {
                                bg: "#FAF5FF",
                            },
                        }}
                        onClick={onClose}
                    >
                        Maybe later
                    </Button>
                </Card>
            </Flex>
        </Modal>
    );
};

export default AppInstallModal;